<template lang='pug'>
  .merchant-nav.fixed.bottom.block.responsive.component(
    v-if='user && account && account.merchant'
    :class='{ scrolled: scrolled }'
  )
    bf-flex.centered.space-between
      router-link.link.customers(:to="{ name: 'customers', params: {} }")
        img.inactive(src='/ui/customer-w.svg')
        img.active(src='/ui/customer-o.svg')
        label {{ $t('Customers') }}

      router-link.link(:to="{ name: 'marketing', params: {} }")
        img.inactive(src='/ui/marketing-w.svg')
        img.active(src='/ui/marketing-o.svg')
        label {{ $t('Marketing') }}

      .divider
        router-link.link.container(:to="{ name: 'dashboard', params: {} }")
          .shadow
          img.inactive(src='/ui/dashboard-g.svg')
          img.active(src='/ui/dashboard-o.svg')

      router-link.link(:to="{ name: 'selling', params: {} }")
        img.inactive(src='/ui/selling-w.svg')
        img.active(src='/ui/selling-o.svg')
        label {{ $t('Selling') }}

      router-link.link(:to="{ name: 'orders', params: {} }")
        img.inactive(src='/ui/orders-w.svg')
        img.active(src='/ui/orders-o.svg')
        label {{ $t('Orders') }}
</template>

<script>
  export default {
    name: 'merchant-nav.component',

    props: {
      user: Object,
      account: [ Object, Array ],
      scrolled: Boolean
    }
  }
</script>

<style scoped lang='stylus'>
  .merchant-nav
    padding 12px 4px
    box-sizing border-box
    box-shadow var(--shadow-box)
    background rgb( 31 69 144)
    z-index 3
    position fixed
    bottom 0
    left 0
    right 0
    .bf-flex
      max-width 680px
      margin 0 auto
    .divider .link
      margin 0 auto
      margin-top -72px
      .shadow
        transform rotate(45deg)
        box-shadow 0 0 20px white
        height 40px
        width 40px
        position absolute
      img
        height 70px
        z-index 1

    .link
      display flex
      justify-content center
      align-items center
      flex-direction column
      margin 0 4px
      width 64px
      color rgb( 255 255 255)
      img
        display block
        height 30px
      .active
        display none
      label
        text-align center
        margin-top 4px
    .router-link-active.link
      color rgb( 255 185 0 )
      font-weight bold
      .inactive
        display none
      .active
        display block

  .merchant-nav.scrolled
    label
      display none

    .divider .link
      margin-top -42px
</style>
